/* global React */
import { Grid } from '@mui/material'
import { useMemoRef, useStyles } from '@platform/react/hook'
import { format } from 'date-fns'
import Text from 'ui/Element/Text'

interface DateProps {
  /** the date value */
  value?: Date | number
}

/**
 * Returns the Date element's current theme styles.
 *
 * @param theme  the application's current theme
 * @returns      the Date element's styles
 */
const styles = (theme: any) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingBottom: '1rem',
  },
  message: {
    padding: '0.5rem',
    borderRadius: '0.5rem',
    color: theme.palette.gray[400],
    backgroundColor: theme.palette.gray[960],
  },
  ...theme.custom.dateMessage,
})

/**
 * Date Message Item.
 *
 * Message item used to display a date.
 *
 * @param props       the element's properties
 * @param props.value the date value
 * @returns           the new Date element
 */
const DateMessage = ({ value }: DateProps) => {
  const classes = useStyles(styles)() as Record<string, string>

  return (
    <Grid
      item
      className={classes.root}
    >
      <Text
        className={classes.message}
        variant={'body2'}
        color={'textSecondary'}
      >
        { value ? format(value, 'd.MM.yyyy.') : 'Loading...'}
      </Text>
    </Grid>
  )
}

export default useMemoRef(DateMessage, (props: DateProps) => [props.value])
